import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Constants
import { SKETCH_WEBSITE } from '@sketch/constants'
import { useFlag } from 'containers/flags'

// Components
import { Dropdown, TableComponents } from '@sketch/components'
import { ButtonItem, ExternalLinkItem } from 'modules/projects/components/Item'

// Local Icons
import { icons } from '../../icons'

// Styles
import { DropdownDivider, DropdownItem } from './OldHelpMenu.styles'

// Config
import { useHubspotChat } from 'utils/hooks/useHubspotChat'

interface HelpMenuProps {
  title?: string
}

const HelpMenu: React.FC<HelpMenuProps> = ({ title = 'Help with Sketch' }) => {
  const hasHubspotChatSupportOn = useFlag('hubspot-chat-support')

  const { loadChat } = useHubspotChat()
  const { search } = useLocation()

  // only try to load the chat on the first load (avoids eternal loops)
  useEffect(() => {
    // check if chatWithUs is on the URl to auto load hubspot chat
    const URLparams = new URLSearchParams(search)
    const isChatWithUsLaunch = URLparams.get('chatWithUs')

    if (isChatWithUsLaunch === 'true') {
      loadChat()
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Dropdown
        toggle={<ButtonItem icon={icons.LifeBelt} text={title} />}
        placement="top"
        contentPadding="8px"
      >
        <DropdownItem>
          <ExternalLinkItem
            icon={icons.Home}
            href={`${SKETCH_WEBSITE}/home`}
            text="sketch.com"
          />
        </DropdownItem>
        <DropdownItem>
          <ExternalLinkItem
            icon={icons.SketchLogo}
            href={`${SKETCH_WEBSITE}/downloads/mac`}
            text="Download the Mac App"
          />
        </DropdownItem>

        <DropdownDivider />

        {/* This is used here since style-wise is the same component */}
        <DropdownItem>
          <TableComponents.TableHeaderCell as="div">
            Get Help
          </TableComponents.TableHeaderCell>
        </DropdownItem>

        <DropdownItem>
          <ExternalLinkItem
            icon={icons.Notebook}
            href={`${SKETCH_WEBSITE}/docs/`}
            text="Documentation"
          />
        </DropdownItem>
        <DropdownItem>
          <ExternalLinkItem
            icon={icons.QuestionMark}
            href={`${SKETCH_WEBSITE}/support/general/`}
            text="Frequently Asked Questions"
          />
        </DropdownItem>
        <DropdownItem>
          <ExternalLinkItem
            icon={icons.Command}
            href={`${SKETCH_WEBSITE}/docs/designing/shortcuts/#web-app-shortcuts`}
            text="Keyboard Shortcuts"
          />
        </DropdownItem>
        {hasHubspotChatSupportOn && (
          <ButtonItem
            icon={icons.ChatIcon}
            onClick={loadChat}
            text="Chat with Us"
          />
        )}
        <DropdownItem>
          <ExternalLinkItem
            icon={icons.MailEnvelope}
            href={`${SKETCH_WEBSITE}/support/contact/`}
            text="Contact Us"
          />
        </DropdownItem>
      </Dropdown>
    </>
  )
}

export default HelpMenu
